import React from 'react';
import cn from 'classnames';

import * as styles from './Wrapper.module.css';

const Wrapper = ({ children, className, tag = 'div' }) => {
  const Tag = tag;

  return <Tag className={cn(styles.root, className)}>{children}</Tag>;
};

export default Wrapper;
